import * as React from "react"
import { Box, Typography } from "@mui/material";

import { BadgeVariant } from "@components"
import  {useUserApp } from "@hooks";


export default function distributionSkuColumn(sort, name, label) {
	return [{
		name, label,
		options: {
			display: 'excluded',
			filterType: 'textField',
			customBodyRowRender: value => value.map(v => v.skuName).join(",")
		}
	}, {
		name: sort, label,
		options: {
			headerAlign: 'left',
			filter: false,
			customBodyRowRenderLite: (_, row) => <SkuCell data={row[name]} />
		}
	}]
}

const SkuCell = ({ data }) => {

	const { userGroupByProductID } = useUserApp()

	return <Box sx={{ display: 'flex', flexDirection: 'column' }}>
		{data.map(({ skuName, numVariants }, idx) => (
			<Box key={idx} sx={{ display: 'flex', alignItems: 'center' }}>
				<Typography key={idx} variant="caption">
					{skuName}
				</Typography>
				{!userGroupByProductID && <BadgeVariant numVariants={numVariants} />}
			</Box>
		))}
	</Box>
}